import { render, staticRenderFns } from "./ChargedVolumeColumnChart.vue?vue&type=template&id=60648a54&"
import script from "./ChargedVolumeColumnChart.vue?vue&type=script&lang=js&"
export * from "./ChargedVolumeColumnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports